module.exports = __webpack_public_path__ + "static/img/order1.2f2c705.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/order1.png
// module id = 1248
// module chunks = 0